import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { Guid } from '@models';
import { BaseDrawerComponent } from '@base/base-drawer.component';
import { TagsTreeComponent } from '@shared/_views/tags-tree/tags-tree.component';
import { TempInfoComponent } from '@shared/_utils/temp-info.component';

@Component({
    selector: 'vz-select-tags-drawer',
    templateUrl: './select-tags-drawer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        NzDrawerModule, NzButtonModule,
        TagsTreeComponent,
        TempInfoComponent
    ],
})
export class SelectTagsDrawerComponent extends BaseDrawerComponent {
    projectId       = input<Guid>();
    mode            = input<'normal' | 'select' | 'multiselect'>('normal');
    showOrgTags     = input(false, { transform: booleanAttribute });
    noHeader        = input(false, { transform: booleanAttribute });
    noCreateButton  = input(false, { transform: booleanAttribute });
    noEditToggle    = input(false, { transform: booleanAttribute });
    showAllProjects = input(false, { transform: booleanAttribute });
    cantBeEmpty     = input(false, { transform: booleanAttribute });
    selected        = model<string[]>();

    canEditProj  = computed<boolean>(() => {
        const pid = this.projectId();
        return !!pid && (
            // this.granted['__manager']
            this.granted['org.admin.projects.update']
            || this.granted['project.update']
            || (this.pGranted[pid] && (this.pGranted[pid]['__manager'] || this.pGranted[pid]['project.update']))
        )
    });

}
